import { unwrap } from '../http.js';
export function createNutritionApi(client) {
    return {
        async targets() {
            return unwrap(await client.GET('/v1/nutrition/targets'));
        },
        async setTargets(body) {
            return unwrap(await client.PUT('/v1/nutrition/targets', { body }));
        },
        async suggestTargets(body) {
            // El contrato exige cuerpo, pero todos sus campos son opcionales: sin
            // argumento se manda `{}` y el servidor lo resuelve todo desde el perfil.
            return unwrap(await client.POST('/v1/nutrition/targets/suggest', { body: body ?? {} }));
        },
    };
}
//# sourceMappingURL=nutrition.js.map